import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-homecard',
  templateUrl: './homecard.component.html',
  styleUrls: ['./homecard.component.scss'],
  standalone: false
})
export class HomecardComponent {

  @Input() srcImg: string = '';
  @Input() appName: string = '';
  @Input() appText: string = '';
  @Input() appUrl: string = '';
  @Input() appInternal: boolean = false;

  readonly defaultImg = 'assets/img/common/logo_webda.png';

  loaded = false;

  onImageLoad() {
    this.loaded = true;
  }

  handleImageError() {
    this.srcImg = this.defaultImg;
  }

  onCardClick(event: MouseEvent) {
    if (this.appInternal) {
      return;
    }
    event.preventDefault();
    window.open(this.appUrl, '_blank', 'noopener,noreferrer');
  }
}
